export default __webpack_public_path__ + "media/images/tenant/timeline/step_3-9f4691f0d5a7632e86d00cf06d863e60.jpg";